import { render, staticRenderFns } from "./img-placeholder.vue?vue&type=template&id=1b2cb5c0&"
import script from "./img-placeholder.vue?vue&type=script&lang=js&"
export * from "./img-placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2cb5c0')) {
      api.createRecord('1b2cb5c0', component.options)
    } else {
      api.reload('1b2cb5c0', component.options)
    }
    module.hot.accept("./img-placeholder.vue?vue&type=template&id=1b2cb5c0&", function () {
      api.rerender('1b2cb5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/skeleton/src/img-placeholder.vue"
export default component.exports